import { useCallback } from 'react';
import { useLazyQuoteApi } from 'Shared/services/Api/makeQuoteApiHttp';
import { useAxiosErrorReporter } from 'Shared/hooks/useAxiosErrorReporter';
import {
  GetConfigResponseType,
  transformConfigResponse,
} from 'QuoteApp/services/endpoints/GetConfig';

export type ConfigProviderType = {
  config: GetConfigResponseType | null;
  configLoading: boolean;
  refreshConfig(): Promise<GetConfigResponseType>;
};

export const useConfig = (appId: string): ConfigProviderType => {
  const [{ loading, error, data }, fetch] =
    useLazyQuoteApi<GetConfigResponseType>({
      method: 'GET',
      url: `insurance_applications/${appId}/configuration`,
      transformResponse: transformConfigResponse,
    });

  useAxiosErrorReporter({
    name: 'configurationError',
    error,
  });

  const refreshConfig = useCallback(async () => (await fetch()).data, [fetch]);

  return {
    config: data,
    configLoading: loading,
    refreshConfig,
  };
};
